<template>
  <div class="wrap">
    <iframe
      class="prism-player"
      :src="pdfUrl"
      width="100%"
      :height="heights"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "pdfStandard",
  data() {
    return {
      pdfUrl: "",
      heights:document.body.clientHeight
    };
  },
  mounted() {
    this.pdfUrl = this.$route.query.pdfUrl;
  },
};
</script>

<style lang='less' scoped>
.wrap {
  height: 100%;
}
</style>